module.exports = __webpack_public_path__ + "img/09.acd959e5.png";